import stepocurrence from '../stepocurrence/stepocurrence.vue'
import inputnewboll from './components/inputnewboll.vue'
import { VueEditor } from 'vue2-editor'
import actionsForm from '@/shared/mixins/actionsForm'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import EnterpriseNewUnit from '@/shared/http/repositories/realestate/enterprisenewunit'
import TechnicianRepository from '@/shared/http/repositories/realestate/technician'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import {mask} from 'vue-the-mask'
import data from './data'
import { loading, toast } from '@/shared/utils/UIHelper'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import REClientRepository from '@/shared/http/repositories/realestate/client'
import { forEach } from 'lodash'

export default {
  mixins: [actionsForm],
  data () {
    return {
      campoUnidade: '',
      tipo: [],
      dataAllenterpriseNewUnit: [],
      EmpreendimentoNovaUnidadeId: null,
      alo: '',
      // camposrquired: ['nomemorador', 'celular', 'email', 'cpf', 'EmpreendimentoNovaUnidadeId'],
      camposrquired: ['nomemorador', 'celular', 'EmpreendimentoNovaUnidadeId'],
      disabledTecnico: true,
      nomeUnidade: '',
      popupPage: 1,
      ptBR: ptBR,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      formnewoccourence: data,
      valuepogrress: 1,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }]
      ],
      hours: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'],
      dataAllenterprise: [],
      dataEmpreendimento: [],
      dataAllenterpriseUnity: [],
      datalAlltenico: [],
      dataAllGetPatologia: [],
      cpfobj: [],
      dataallStatusOcorrencia: [],
      dataTenicalHour: [],
      tecnicoObj: {
        type: Object,
        default: {}
      },
      disableright: false,
      changeMonth: false,
      disableleft: false,
      stepdays: 1,
      testeee: 'sadasdasdasdasdasd',
      months: [
        { name: 'Janeiro', color: '#28a745' },
        { name: 'Fevereiro', color: '#28a745' },
        { name: 'Março', color: '#28a745' },
        { name: 'Abril', color: '#28a745' },
        { name: 'Maio', color: '#28a745' },
        { name: 'Junho', color: '#28a745' },
        { name: 'Julho', color: '#28a745' },
        { name: 'Agosto', color: '#28a745' },
        { name: 'Setembro', color: '#28a745' },
        { name: 'Outubro', color: '#28a745' },
        { name: 'Novembro', color: '#28a745' },
        { name: 'Dezembro', color: '#28a745' }
      ],
      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      days: [],
      currentMonthIndex: null,
      selectedDate: null,
      daysofweeks: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sabado'],
      daysofYears: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO']
    }
  },
  name: 'addocurrence',
  components: {
    VueEditor,
    stepocurrence,
    Datepicker,
    inputnewboll
  },
  watch: {
    'formnewoccourence.dataSolicitacao': function (value) {
      if (this.twoselect === false) {
        this.getHoursTecnico()
      }
      if (value !== null) {
        this.disabledTecnico = false
      }
    }
  },
  computed: {
    twoselect: function () {
      if (this.formnewoccourence.dataSolicitacao === null || this.formnewoccourence.tecnicoid === null) {
        return false
      }
      this.stepdays = this.getWeekOfMont(this.formnewoccourence.dataSolicitacao.getDate()) - 1
      return true
    },
    getMonthName () {
      return this.daysofYears[this.formnewoccourence.dataSolicitacao.getMonth()]
    },
    verificarpatologiaselect () {
      alert('teste')
    },
    getDays () {
      let data = []
      this.hours.forEach((hour) => {
        var tecnicoid = this.formnewoccourence.tecnicoid
        let verify = []
        if (this.dataTenicalHour != null) {
          verify = this.dataTenicalHour.filter((Element) => {
            let format = this.formatHours(Element.hours)
            if (format === hour) {
              let validar = false
              if (Element.reOccurence == null) {
                validar = true
              } else {
                Element.reOccurence.filter((Element) => {
                  if (Element.tecnicoId === tecnicoid) validar = true
                })
              }
              return validar
            }
            return false
          })
        }
        let obj = {
          value: hour,
          disabled: verify.length > 0
        }
        data.push(obj)
      })
      return data
    },
    getcarouselDays () {
      let datalast = this.getfinalMonth()
      let adddays = this.stepdays * 7
      let dias = []
      this.disableright = false
      this.disableleft = false
      let sevendays = 7
      let dayStart = this.getStartMonth()
      let secondweeks = 0
      let mesCalenders = this.formnewoccourence.dataSolicitacao.getMonth()
      for (var i = adddays; i < (7 + adddays); i++) {
        if (adddays >= 7 && i === adddays) {
          dayStart.setDate(adddays - dayStart.getDay())
          secondweeks = dayStart.getDate() + 1
        }
        if (datalast.getDate() < secondweeks) continue
        if (dayStart.getDay() !== 0 && i === 0) {
          let diasOld = 0
          for (var olddias = dayStart.getDay(); olddias > 0; olddias--) {
            if (olddias === dayStart.getDay()) {
              let monthactualy = this.getStartMonth()
              monthactualy.setMonth(mesCalenders - 1)
              diasOld = this.getfinalMonthCus(monthactualy).getDate()
            }
            let data = {
              value: (diasOld + 1) - olddias,
              disable: true
            }
            this.disableleft = true
            dias.push(data)
            if ((diasOld - olddias) === diasOld) break
            sevendays = sevendays - 1
            if (sevendays === 0) break
          }
        }
        if (secondweeks !== 0) {
          let data = {
            value: secondweeks,
            disable: false
          }
          if (secondweeks === datalast.getDate()) {
            this.disableright = true
          }
          dias.push(data)
          secondweeks = secondweeks + 1
        } else {
          let data = {
            value: i + 1,
            disable: false
          }
          if ((i + 1) === 1) {
            this.disableleft = true
          }
          if ((i + 1) === datalast.getDate()) {
            this.disableright = true
          }
          dias.push(data)
        }
        sevendays = sevendays - 1
        if (sevendays !== 0 && datalast.getDate() === secondweeks - 1) {
          let totalseven = sevendays
          let daysfal = 1
          while (daysfal <= totalseven) {
            let data = {
              value: daysfal,
              disable: true
            }
            this.disableright = true
            dias.push(data)
            daysfal++
            sevendays = sevendays - 1
          }
        }
        if (sevendays === 0) break
      }
      return dias
    }
  },
  mounted () {
    this.getEmpreendimento()
    this.getallproblamRaiz()
    this.GetPatologia()
    this.getAllTenico()
    // this.GetEmpreendimentoById()
    // this.getApartamento()
  },
  directives: {mask},
  methods: {
    getWeekOfMont (day) {
      /*eslint-disable*/
      let week = 0
      let datalast = this.getfinalMonth()
      var WeekWhile = true
      let dias = []
      this.disableright = false
      this.disableleft = false
      let sevendays = 7
      let secondweeks = 0
      let mesCalenders = this.formnewoccourence.dataSolicitacao.getMonth()
      while(WeekWhile) {
        dias =  []
        let dayStart = this.getStartMonth()
        let adddays = week* 7
        week = week + 1
        for (var i = adddays; i < (7 + adddays); i++) {
          if (adddays >= 7 && i === adddays) {
            dayStart.setDate(adddays - dayStart.getDay())
            secondweeks = dayStart.getDate() + 1
          }
          if (datalast.getDate() < secondweeks) continue
          if (dayStart.getDay() !== 0 && i === 0) {
            let diasOld = 0
            for (var olddias = dayStart.getDay(); olddias > 0; olddias--) {
              if (olddias === dayStart.getDay()) {
                let monthactualy = this.getStartMonth()
                monthactualy.setMonth(mesCalenders - 1)
                diasOld = this.getfinalMonthCus(monthactualy).getDate()
              }
              let data = {
                value: (diasOld + 1) - olddias,
                disable: true
              }
              this.disableleft = true
              dias.push(data)
              if ((diasOld - olddias) === diasOld) break
              sevendays = sevendays - 1
              if (sevendays === 0) break
            }
          }
          if (secondweeks !== 0) {
            let data = {
              value: secondweeks,
              disable: false
            }
            if (secondweeks === datalast.getDate()) {
              this.disableright = true
            }
            dias.push(data)
            secondweeks = secondweeks + 1
          } else {
            let data = {
              value: i + 1,
              disable: false
            }
            if ((i + 1) === 1) {
              this.disableleft = true
            }
            if ((i + 1) === datalast.getDate()) {
              this.disableright = true
            }
            dias.push(data)
          }
          sevendays = sevendays - 1
          if (sevendays !== 0 && datalast.getDate() === secondweeks - 1) {
            let totalseven = sevendays
            let daysfal = 1
            while (daysfal <= totalseven) {
              let data = {
                value: daysfal,
                disable: true
              }
              this.disableright = true
              dias.push(data)
              daysfal++
              sevendays = sevendays - 1
            }
          }
          if (sevendays === 0) break
        }
        let verificar = dias.filter((Element) => Element.value == day)
        if(verificar.length > 0) break
        }
      return week
     
    },
    setdayInitial () {
      let dayinput = document.getElementById('day-' + this.formnewoccourence.dataSolicitacao.getDate())
      if (dayinput === undefined || dayinput === null) return
      dayinput.classList.add('one-day-active')
    },
    GetnameWeek (month) {
      return this.daysofweeks[month].substring(0,3)
    },
    formatadatas(date) {
      let formated =  Intl.DateTimeFormat("pt-br").format(date)
      return formated
    },
    nextstepdays () {
      this.stepdays =  this.stepdays + 1
    },
    downstepdays() {
      this.stepdays = this.stepdays - 1
    },
    popupcurrenceOpen () {
      Object.keys(this.formnewoccourence).forEach((Element) => {
        if(typeof this.formnewoccourence[Element] === 'boolean') this.formnewoccourence[Element] = false
        else this.formnewoccourence[Element] = null
      })
      this.valuepogrress = 0
      this.dataTenicalHour = []
      this.$refs['popupcurrence-modal'].show()
    },
    verificarDataSelcionada (data) {
      if (this.formnewoccourence.dataSolicitacao.getDate() === data) return true
      return false
    },
    setMonthDown(){
      this.stepdays = 0
      this.changeMonth = true
      this.formnewoccourence.dataSolicitacao.setMonth(this.formnewoccourence.dataSolicitacao.getMonth() - 1)
      this.formnewoccourence.dataSolicitacao = new Date(this.formnewoccourence.dataSolicitacao)
      this.GetHourWithTennicaid()
    },
    setMonthplus () {
      this.stepdays = 0
      this.changeMonth = true
      this.formnewoccourence.dataSolicitacao.setMonth(this.formnewoccourence.dataSolicitacao.getMonth() + 1)
      this.formnewoccourence.dataSolicitacao = new Date(this.formnewoccourence.dataSolicitacao)
      this.GetHourWithTennicaid()
    },
    selectDay (day) {
      let inputactive  = document.querySelectorAll('.one-day-active')
      let dayid = document.getElementById('day-' + day)
      if(dayid.classList.contains('one-day-disabled')) return
      if(inputactive !== null && inputactive !== undefined) {
        inputactive.forEach((Element) => {
          Element.classList.remove('one-day-active')
        })
      }
      this.resetHour()
      this.formnewoccourence.dataSolicitacao.setDate(day)
      this.formnewoccourence.dataSolicitacao = this.formnewoccourence.dataSolicitacao
      
      dayid.classList.add('one-day-active')
      this.GetHourWithTennicaid()

    },
    changeTecnico () {
      if(this.formnewoccourence.tecnicoid === '') this.dataTenicalHour = []
      if(this.formnewoccourence.tecnicoid != '' && this.formnewoccourence.tecnicoid != null)
        this.GetHourWithTennicaid()
    },
    GetHourWithTennicaid () {
        let data = {
          DataChosen: this.formnewoccourence.dataSolicitacao
        }
        loading.push()
        OcurrenceRepository.GetHourWithTennicaid(this.formnewoccourence.tecnicoid, data)
          .then((Response) => {
            this.dataTenicalHour = Response.data
            loading.pop()
          })
          .catch((Error) => {
            loading.pop()
          })
    },
    getWeek (date) {
      let monthStart = new Date(date);
      monthStart.setDate(0);
      let offset = (monthStart.getDay() + 1) % 7 - 1; // -1 is for a week starting on Monday
      return Math.ceil((date.getDate() + offset) / 7);
    },
    popupcurrenceClose () {
      this.$refs['popupcurrence-modal'].hide()
    },
    setGarantia (newvlaue) {
      this.formnewoccourence.garantia = newvlaue
    },
    getfinalMonthCus (date) {
      let lastdate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return lastdate
    },
    getfinalMonth () {
      let lastdate = new Date(this.formnewoccourence.dataSolicitacao.getFullYear(), this.formnewoccourence.dataSolicitacao.getMonth() + 1, 0)
      return lastdate
    },
    getStartMonth () {
      let startmonth = new Date(this.formnewoccourence.dataSolicitacao.getFullYear(), this.formnewoccourence.dataSolicitacao.getMonth(), 1)
      return startmonth
    },
    setManutencaocortesia (value) {
      this.formnewoccourence.cortesia = value
    },
    GetPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          loading.pop()
          this.dataAllGetPatologia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getAllTenico () {
        TechnicianRepository.GetAll()
        .then((Response) => {
          this.datalAlltenico = Response.data
        })
        .catch((Error) => {

        })
    },
    setManutencaoGarantia (newvlaue) {
      this.formnewoccourence.manutencaogarantia  = newvlaue
    },
    nextPopupPages () {
      if(this.valuepogrress == 0) {
        if(!this.verifyproblam())
          return
      }
      if(this.valuepogrress == 1) {
        if(!this.verifydescription())
          return
      }
      if(this.valuepogrress == 2) {
        if(!this.verifyForm())
          return
      }
      if(this.valuepogrress === 3) {
        this.inserir()
        return
      }
      this.valuepogrress = this.valuepogrress+1

    },
    resetHour() {
      this.formnewoccourence.horario = null
      let inputhoursactived = document.querySelectorAll('.hour-active')
      if (inputhoursactived !== null) {
        inputhoursactived.forEach((Element) => {
          Element.classList.remove('hour-active')
        })
      }
    },
    iconselector (e) {
      if (e === 0) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Infiltracao.svg'
      if (e === 1) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Eletrico.svg'
      if (e === 2) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pisos_Revestimento.svg'
      if (e === 3) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Esquadrias.svg'
      if (e === 4) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Vedacao.svg'
      if (e === 5) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pintura.svg'
      if (e === 6) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Loucas.svg'
      if (e === 7) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Hidraulica.svg'
      if (e === 8) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Tubulacoes.svg'
      if (e === 9) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Estrutura.svg'
      if (e === 10) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Impermeabilizacao.svg'
      if (e === 11) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Outros.svg'
    },
    sethour(hour) {
     let input = document.querySelectorAll('.hour-active')
     let divhour = document.getElementById('hour-' + hour)
     if(divhour.classList.contains('hour-disable')) return
     if(input !== null || input !== undefined) {
       input.forEach((Element) => Element.classList.remove('hour-active'))
     }
     this.formnewoccourence.horario = hour
     divhour.classList.add('hour-active')

    },
    verifyFormData () {
      // if(this.formnewoccourence.horario != null && this.formnewoccourence.dataSolicitacao != null && (this.formnewoccourence.tecnicoid != null || this.formnewoccourence.tecnicoid != '')) return true
      // if(this.formnewoccourence.horario == null) toast.error('Selecione um Horario!!')
      // if(this.formnewoccourence.dataSolicitacao == null) toast.error('Selecione uma Data!!')
      // if(this.formnewoccourence.tecnicoid == null || this.formnewoccourence.tecnicoid == '' ) toast.error('Selecione um Técnico!!')
      return true  
        
    },
    verifyForm () {
      let error = []
      this.camposrquired.forEach((Element) => {
        if (this.formnewoccourence[Element] === null) error.push(Element)
      })
      if(error.length > 0) {
        error.forEach((Element) => {
          let name = Element
          if(Element === 'nomemorador') name = 'Nome do Morador'
          if(Element === 'empreendimentoid') name = 'Empreendimento'
          toast.error(`O campo ${name} não foi preenchido!!`)
        })
       
        return false
      }
      // if(!this.formnewoccourence.email.includes('@')){
      //   toast.error(`O campo E-mail esta invalido!!`)
      //   return false
      // }
      return true
    },
    getallproblamRaiz() {
      loading.push()
      OcurrenceRepository.GetStatusOcorrencia()
        .then((Response) => {
          loading.pop()
          this.dataallStatusOcorrencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    formatHours(hour) {
      if (hour != null) {
        if(!hour.toString().includes('.')) {
          return hour.toString() + ":00"
        } else {
          return hour.toString().replace(".", ':') + "0"
        } 
      } else {
          return false
      }

    },
    verificarTecnicoAndHour(hour) {
      var tecnicoid = this.formnewoccourence.tecnicoid
      let verify = this.dataTenicalHour.filter((Element) => {
        let format = this.formatHours(Element.hours)
        if(format ==  hour ) {
          let validar = false
          Element.reOccurence.filter((Element) => {
            if(Element.tecnicoId == tecnicoid) validar = true
          })
         return validar > 0 ? true : false
        }
        return false
        
      })
      if(verify.length > 0) return true
        return false
    },
    getTecnico(id) {
        let tecnico = this.datalAlltenico.find((Element) => Element.id == id)
        if(tecnico == null || tecnico == undefined ) return " - "
        return tecnico.nome
    
    },
    getproblemaraiz(value){
      let problemaRaiz = this.dataAllGetPatologia.find((Element) => Element.value == value)
      if(problemaRaiz == null || problemaRaiz == undefined ) return " - "
      return problemaRaiz.text
    },
    getEmpreendimentoId(id){
      let empreendimento = this.dataAllenterpriseNewUnit.find((Element) => Element.id == id)
      if(empreendimento == null || empreendimento == undefined ) return " - "
      return empreendimento.nomeUnidade
    },
    getEmpreendimentounidadeid(id){
      let empreendimentounidade = this.dataAllenterpriseUnity.find((Element) => Element.id == id)
      if(empreendimentounidade == null || empreendimentounidade == undefined ) return " - "
      return empreendimentounidade.nomeApartamento
    },
    getEmpreendimento () {  
      EnterpriseNewUnit.GetNovaUnidade()
        .then((Response) => {
          forEach
          this.dataAllenterpriseNewUnit = []
          Response.data.forEach(i => {
            this.dataAllenterpriseNewUnit.push({
              id: i.id,
              nomeUnidade: i.nomeEmpreendimento
            })
          })
        })
        .catch((Error) => {

        })
    },
    TipoUnidadeEmpreendimento (data){
      EnterpriseRepository.GetTipoByEmpreendimentoId(data).then((Response) => {
        console.log(Response.data[0].tipo)
        this.TipoUnidadeEmpreendimentos (Response.data[0].tipo)

      })
      .catch((Error) => {

      })
    },

    TipoUnidadeEmpreendimentos (tipo){
        if (tipo !== null || tipo != undefined) {  
          if(tipo == 0) {
            this.campoUnidade = 'Unidade'
            this.getEmpreendimentoUnidade()
          } else if (tipo == 1) {
            this.campoUnidade = 'Lote'
            this.getEmpreendimentoUnidade()
          } else {
            this.campoUnidade = 'Casa'
            this.getEmpreendimentoUnidade()
          }
         
        }
    },


    GetEmpreendimentoById (e) {
      REClientRepository.GetEmpreendimentoByUnidadeEmpreendimento()
        .then((Response) => {
          this.dataAllenterprise = Response.data
          if (this.dataAllenterprise.length == 1){
            this.formnewoccourence.empreendimentoid = Response.data[0].empreendimentoId
          }
        })
        .catch((Error) => {

        })
    },
    
    getApartamento () {
      EnterpriseUnityRepository.GetApartamento(this.formnewoccourence.empreendimentoid, this.formnewoccourence.cpf)
        .then((Response) => {
          this.dataAllenterpriseUnity = Response.data
          if (this.dataAllenterpriseUnity.length == 1){
            this.formnewoccourence.empreendimentounidadeid = Response.data[0].empreendimentounidadeid
          }
        })
        .catch((Error) => {
          
        })
    },
    getEmpreendimentoUnidade () {
      EnterpriseUnityRepository.GetAllByEmpreendimentoId(this.formnewoccourence.empreendimentoid)
        .then((Response) => {
          this.dataAllenterpriseUnity = Response.data.data
        })
        .catch((Error) => {

        })
    },
    verifyproblam() {
      // Se não for array ou estiver vazio, dá o erro
      if (!Array.isArray(this.formnewoccourence.patologia) || this.formnewoccourence.patologia.length === 0) {
        toast.warning('Selecione um patologia!!')
        return false
      } else {
        return true
      }
    },
    verifydescription () {
      if(this.formnewoccourence.descricao == null || this.formnewoccourence.descricao == '') {
        toast.warning("É obrigatorio o preenchimento do campo observação!!!")
        return false
      }
      return true
    },
    // setvalueProblem(value) {
    //   this.formnewoccourence.patologia  = value
    //   let divs = document.querySelectorAll('.divchamado-actived')
    //   if(divs != null && divs != undefined) {
    //     divs.forEach((Element) => {
    //       Element.classList.remove('divchamado-actived')
    //     })
    //   }
    //   document.getElementById('panel-chamado-' + value).classList.add('divchamado-actived')
    // },

    setvalueProblem(value) {
  // Garante que patologia seja um array
      if (!Array.isArray(this.formnewoccourence.patologia)) {
        this.formnewoccourence.patologia = []
      }

      const index = this.formnewoccourence.patologia.indexOf(value)
      const panel = document.getElementById('panel-chamado-' + value)

      if (index !== -1) {
        // Se já existe, remove da lista e remove a classe ativa
        this.formnewoccourence.patologia.splice(index, 1)
        if (panel) panel.classList.remove('divchamado-actived')
      } else {
        // Se não existe, adiciona à lista e ativa visualmente
        this.formnewoccourence.patologia.push(value)
        if (panel) panel.classList.add('divchamado-actived')
      }
    },

    backPopupPages () {
 
     
      this.valuepogrress = this.valuepogrress - 1

      switch (this.valuepogrress) {
        case 0:
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          break;   
        default:
          break;
      }
    },
    nextSlide: function() {
      this.currentSlide++;
      if (this.currentSlide >= this.months.length) {
        this.currentSlide = 0;
      }
    },
    prevSlide: function() {
      this.currentSlide--;
      if (this.currentSlide < 0) {
        this.currentSlide = this.months.length - 1;
      }
    },
    isToday(day) {
      const today = moment();
      return day.date === today.date() && day.month === today.month() && day.year === today.year();
    },
    isSelected(day) {
      return day.date === (this.selectedDate ? this.selectedDate.date : null) && day.month === (this.selectedDate ? this.selectedDate.month : null) && day.year === (this.selectedDate ? this.selectedDate.year : null);
    },
    selectDate(day) {
      if (day.month === this.currentMonthIndex) {
        this.selectedDate = {
          date: day.date,
          month: day.month,
          year: day.year
        };
      }
    },
    getHoursTecnico() {
      loading.push()
      let data = {
        DataChosen: this.formnewoccourence.dataSolicitacao
      }
      OcurrenceRepository.GetTecnicoAndHours(data)
      .then((Response) => {
        this.dataTenicalHour = Response.data
        loading.pop()
      })
      .catch((Error) => {
        loading.pop()
      })
    },
    inserir () {
      loading.push()
      if (this.formnewoccourence.horario != null) {
        this.formnewoccourence.horario = parseFloat(this.formnewoccourence.horario.replace(':', '.'))
      }
      OcurrenceRepository.Inserir(this.formnewoccourence)
        .then((Response) => {
          if(Response.data) {
            this.popupcurrenceClose()
            toast.success("Ocorrencia salva com sucesso!!")
            this.$emit('reload')
          } else {
            toast.error("Não foi possivel salvar a ocorrencia!!")
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.error("Não foi possivel salvar a ocorrencia!!")
        })
    },
    showModal () {
      this.$refs['my-modal'].show()
      this.$bvModal.hide('popuptecnico-modal')
      this.getTecnico()
    },
    closeModal () {
      this.$refs['popupcurrence-modal'].hide()
    },
    openPopupTecnico () {
      this.$refs['popuptecnico-modal'].show()
      this.getTecnico()
    },
    back () {
      this.$refs['my-modal'].hide()
      this.openPopupTecnico()
    },
    addTecnico () {
      loading.push()
      TechnicianRepository.Post(this.tecnicoObj)
        .then((Response) => {
           loading.pop()
          if (Response.data) {
            toast.success('Técnico inserido com sucesso!')
          } else {
            toast.error('Não foi possivel salvar um técnico!')
          }
          this.back()
        })
        .catch((Error) => {
          loading.pop()
          console.error(Error)
        })
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/addocurrence/addocurrence.js